import React from "react";
import { useParams } from "react-router-dom";
import { BitmakerAPIClient } from "../../services/BitmakerApp";
import {
  Account,
  AccountFromJSON,
  AccountProjectBreakdown,
  AccountProjectBreakdownFromJSON,
} from "../../bitmaker/schemas/Account";
import ReactDatePicker from "react-datepicker";
import { bind } from "bind-decorator";
import { getMonthRange } from "../../utils";

interface Props {
  id: string;
}

interface State {
  account?: Account;
  selectedMonth: Date | null;
  projectBreakdown: Array<AccountProjectBreakdown>;
}

class AccountPageContent extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      account: undefined,
      selectedMonth: new Date(),
      projectBreakdown: [],
    };
  }

  componentDidMount() {
    const handleResponse = (res: any) => {
      this.setState({
        account: AccountFromJSON(res.data),
      });
    };

    BitmakerAPIClient.get(`/accounts/${this.props.id}`, null, handleResponse);

    this.changeReportMonth(this.state.selectedMonth);
  }

  @bind changeReportMonth(selectedMonth: Date | null) {
    if (selectedMonth) {
      this.setState({
        selectedMonth,
      });

      const handleResponse = (res: any) => {
        this.setState({
          projectBreakdown: (res.data as Array<string>).map(
            AccountProjectBreakdownFromJSON
          ),
        });
      };

      const monthRange = getMonthRange(selectedMonth);

      BitmakerAPIClient.get(
        `/accounts/${this.props.id}/time`,
        {
          from: `${monthRange.year}-${monthRange.month}-${monthRange.firstDay}`,
          to: `${monthRange.year}-${monthRange.month}-${monthRange.lastDay}`,
        },
        handleResponse
      );
    }
  }

  public render() {
    return this.state.account ? (
      <div className="project-page">
        <h1>{this.state.account.name}</h1>
        <div className="project-page-breakdown">
          <ReactDatePicker
            selected={this.state.selectedMonth}
            onChange={this.changeReportMonth}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            inline
          />
          <div className="project-breakdown-container">
            <div className="project-breakdown-item">
              <div className="pbitem project-breakdown-item-id">Project ID</div>
              <div className="pbitem project-breakdown-item-earnings">
                Earnings
              </div>
              <div className="pbitem project-breakdown-item-expenses">
                Expenses
              </div>
            </div>
            {this.state.projectBreakdown.map((breakdown, index) => {
              return (
                <div key={index} className="project-breakdown-item">
                  <div className="pbitem project-breakdown-item-id">
                    {breakdown.project_id}
                  </div>
                  <div className="pbitem project-breakdown-item-earnings">
                    {breakdown.earnings}
                  </div>
                  <div className="pbitem project-breakdown-item-expenses">
                    {breakdown.expenses}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    ) : null;
  }
}

const AccountPage = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return <div>Loading account details...</div>;
  return <AccountPageContent id={id} />;
};

export default AccountPage;
